import Carousel from "react-bootstrap/Carousel";

function BootstrapCarousel() {
  return (
    <Carousel indicators={true} controls={false} variant="light">
      <Carousel.Item>
        <img
          style={{ height: "45rem", width: "auto", objectFit: "cover" }}
          className="d-block w-100"
          src="/banners/one.jpeg"
          alt="First slide"
        />
        <Carousel.Caption
          style={{
            left: "3rem",
            top: "3rem",
            position: "absolute",
            color: "black",
            textAlign: "left",
            maxWidth: "57.7rem",
          }}
        >
          <h3 className="hero__seven__text__one">
            Trade the stock markets
            <br />
            on a reliable platform.
          </h3>
          <p className="hero__seven__supporting__text__one">
            Gain access to 100+ Stock, Commodities, Crypto and Forex Access on a
            reliable platform.
          </p>

          <br />
          {/* <button className='hero__seven__button__blue'>Get Started</button> */}
          <a href="https://app.bitfmfund.com">
            <button
              style={{
                backgroundColor: "#1199fa",
                padding: " 0.8rem 1.5rem",
                borderRadius: "0.8rem",
                borderColor: "#1199fa",
                color: "#fff",
                outline: "none",
                border: "none",
                fontWeight: "bold",
                boxShadow: "none",
                margin: "0rem 0.2rem",
                minWidth: "18.0rem",
                boxSizing: "border-box",
              }}
            >
              Get started
            </button>
          </a>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          style={{ height: "45rem", width: "auto", objectFit: "cover" }}
          className="d-block w-100"
          src="/banners/two.jpeg"
          alt="First slide"
        />
        <Carousel.Caption
          style={{
            left: "3rem",
            top: "3rem",
            position: "absolute",
            color: "black",
            textAlign: "left",
            maxWidth: "57.7rem",
          }}
        >
          <h3 className="hero__seven__text__one">
            Experience global markets at the
            <br />
            palm of your hands.
          </h3>
          <p className="hero__seven__supporting__text__one">
            Enjoy trading at the lowest market rates.
          </p>

          <br />
          {/* <button className='hero__seven__button__blue'>Get Started</button> */}
          <a href="https://app.bitfmfund.com">
            <button
              style={{
                backgroundColor: "#fff",
                padding: " 0.8rem 1.5rem",
                borderRadius: "0.8rem",
                borderColor: "#fff",
                color: "#1199fa",
                outline: "none",
                border: "none",
                fontWeight: "bold",
                boxShadow: "none",
                margin: "0rem 0.2rem",
                minWidth: "18.0rem",
                boxSizing: "border-box",
              }}
            >
              Get started
            </button>
          </a>
        </Carousel.Caption>
      </Carousel.Item>
      {/* <Carousel.Item>
        <img
         style={{height: "45rem", width: "auto", objectFit: "cover"}}
          className="d-block w-100"
          src="/banners/one.jpeg"
          alt="First slide"
        />
        <Carousel.Caption style={{left: "3rem", top:"3rem", position: "absolute", color: "black", textAlign: "left", maxWidth: "45.7rem"}}>
          <h3 className='hero__seven__text'>A New Way to
          <br/>
Trade the Future</h3>
          <p className='hero__seven__supporting__text'>IBKR EventTrader lets investors use event contracts to trade their opinion on yes-or-no questions in key markets.</p>

<br />

          <button style={{backgroundColor: "#1199fa", padding: " 1.2rem 3rem", borderRadius: "0.4rem", borderColor: "#0b56bf", color: "white", outline: "none", border: "none", fontWeight: "bold", boxShadow: "none", margin: "0rem 0.2rem", minWidth: "18.0rem", boxSizing: "border-box"  }}>Get started</button>
        </Carousel.Caption>
      </Carousel.Item> */}
      {/* <Carousel.Item>
        <img
         style={{height: "45rem", width: "auto", objectFit: "cover"}}
          className="d-block w-100"
          src="https://www.interactivebrokers.com/images/web/hero-banner-home-eventtrader.jpg"
          alt="First slide"
        />
        <Carousel.Caption style={{left: "3rem", top:"3rem", position: "absolute", color: "black", textAlign: "left", maxWidth: "45.7rem"}}>
          <h3 className='hero__seven__text'>A New Way to
          <br/>
Trade the Future</h3>
          <p className='hero__seven__supporting__text'>IBKR EventTrader lets investors use event contracts to trade their opinion on yes-or-no questions in key markets.</p>

<br />
          <button style={{backgroundColor: "#0b56bf", padding: " 1.2rem 3rem", borderRadius: "2rem", borderColor: "#0b56bf", color: "white", outline: "none", border: "none", fontWeight: "bold", boxShadow: "none", margin: "0rem 0.2rem", minWidth: "18.0rem", boxSizing: "border-box"  }}>Learn More</button>
        </Carousel.Caption>
      </Carousel.Item> */}
    </Carousel>
  );
}

export default BootstrapCarousel;
